// extracted by mini-css-extract-plugin
export default {"test":"App_test__RQVMD"};